export default "__VITE_ASSET__Bz72K0ge__"